import { Grid, CardContent, Card, Box, styled } from "@mui/material";
import { Container } from "@mui/system";
import { paletteVar, Typography } from "@platform/design-system";

import { CurrentClient, ProspectClient } from "../../assets";
import { Title } from "../RFP/components";
import {
  CLIENT_TYPES,
  CLIENT_FORM,
  CLIENT_REDUCER_ACTIONS,
} from "../../constants/client";

const GradientBox = styled(Box)(() => ({
  background:
    "linear-gradient(89.89deg, rgba(110, 30, 108, 0.9) 38.88%, rgba(0, 120, 162, 0.9) 105.32%, rgba(79, 179, 205, 0.9) 139.34%)",
  borderRadius: 99,
  width: "100%",
  backgroundSize: "100% 100px",
  backgroundRepeat: "no-repeat",
  marginLeft: "auto",
  height: 100,
}));

const SelectionCard = styled(Card)(({ theme }) => ({
  "&:hover": {
    backgroundColor: paletteVar(
      "surfaces-primary",
      theme.palette.surfaces.primary,
    ),
    cursor: "pointer",
  },
  "&.selected": {
    backgroundColor: paletteVar(
      "surfaces-primary",
      theme.palette.surfaces.primary,
    ),
  },
}));

const { UPDATE_CLIENT_FIELD, CLEAN_CLIENT } = CLIENT_REDUCER_ACTIONS;

const { CLIENT_TYPE } = CLIENT_FORM;

const ClientTiles = ({ children, client, setClient }) => {
  const currClientType = client[CLIENT_TYPE];

  const handleTileClick = (type) => {
    if (currClientType !== type) {
      setClient({ type: CLEAN_CLIENT });
      setClient({
        type: UPDATE_CLIENT_FIELD,
        name: CLIENT_TYPE,
        value: type,
      });
    }
  };

  const renderClientTiles = () => (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      size={12}
      spacing={{
        xs: 5,
        lg: 4,
      }}
    >
      <Grid size={{ xs: 4, lg: 3 }} textAlign={"center"}>
        <SelectionCard
          data-testid="client-tile-current"
          className={
            client[CLIENT_TYPE] === CLIENT_TYPES.CURRENT_CLIENT
              ? "selected"
              : undefined
          }
          onClick={() => handleTileClick(CLIENT_TYPES.CURRENT_CLIENT)}
        >
          <CardContent>
            <Box
              mt={5}
              mb={1}
              component="img"
              src={CurrentClient}
              alt="Client"
              width={97}
              height={100}
            />
            <Typography variant="header-large" mb={3}>
              Client
            </Typography>
          </CardContent>
        </SelectionCard>
      </Grid>
      <Grid size={{ xs: 4, lg: 3 }} textAlign={"center"}>
        <SelectionCard
          className={
            client[CLIENT_TYPE] === CLIENT_TYPES.PROSPECT_CLIENT
              ? "selected"
              : undefined
          }
          onClick={() => {
            handleTileClick(CLIENT_TYPES.PROSPECT_CLIENT);
          }}
        >
          <CardContent>
            <Box
              mt={5}
              mb={1}
              component="img"
              src={ProspectClient}
              cursor="pointer"
              alt="Prospect"
              width={97}
              height={100}
            />
            <Typography variant="header-large" mb={3}>
              Prospect
            </Typography>
          </CardContent>
        </SelectionCard>
      </Grid>
    </Grid>
  );

  return (
    <Container>
      <Box mb={5} mt={18}>
        <Grid container>
          <Title
            title="Select A Client For Your RFP"
            subtitle="Who is this RFP for?"
          />
          <GradientBox mt={12} mr="auto" />
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            mt={-22}
            size={12}
          >
            {renderClientTiles()}
            <Grid size={12}>{children}</Grid>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default ClientTiles;
